import { FormEvent, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { criptografarDado } from '../../helpers';
import { GrupoLista, propsUsuariosVinculados } from '../../interfaces/grupos';
import { atualizarGruposUsuario, listarGrupos } from '../../services/grupos';
import { Button } from '../Styles';

export default function ModalTransferenciaGrupo({ idGrupoAntigo }: propsUsuariosVinculados) {
    const { modalSecundarioExibir, atualizarDados } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false)
    const [grupos, setGrupos] = useState<GrupoLista[]>([]);
    const [idGrupoSelecionado, setIdGrupoSelecionado] = useState<number | null>(null);

    const onTransferir = async (e: FormEvent) => {
        e.preventDefault()
        if (!idGrupoAntigo) return toast.warning("Grupo não encontrado.")
        if (!idGrupoSelecionado) return toast.warning("Selecione um Grupo.")
        setProcessando(true)

        try {
            const payload = {
                idGrupoAntigo: criptografarDado(idGrupoAntigo.toString()),
                idGrupoNovo: criptografarDado(idGrupoSelecionado.toString())
            }
            const resposta = await atualizarGruposUsuario(payload)

            if (resposta.status === 200) {
                atualizarDados()
                modalSecundarioExibir("")
                return toast.success("Usuarios Migrados com Sucesso.")
            }

        } catch {
            toast.error("Erro ao Migrar os Usuarios para outro Grupo.")
        } finally {
            setProcessando(false)
        }
    }

    useEffect(() => {
        const buscarGrupos = async () => {
            try {
                const resposta = await listarGrupos({ titulo: "", situacao: "Ativo" })

                if (resposta.status === 200 && resposta.data !== null) {
                    setGrupos(resposta.data)
                }

                return
            } catch {
                toast.error("Erro ao buscar os Grupos.")
            }
        }
        buscarGrupos()
    }, [])

    return (
        <div id='fundoModal'>
            <section className='containerModalCentro'>
                <span id='novoContainerTitulo'>
                    <p>Transferir Usuários</p>
                </span>
                <form id='formModalNovo' onSubmit={onTransferir}>
                    <select defaultValue={idGrupoSelecionado || ""} onChange={(e) => setIdGrupoSelecionado(Number(e.target.value))}>
                        <option value=''>Selecione um Grupo</option>
                        {grupos.map((grupo) => (
                            <option key={grupo.id} value={grupo.id.toString()}>{grupo.titulo}</option>
                        ))}
                    </select>

                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalSecundarioExibir("")}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>Salvar Dados</Button>
                    </span>
                </form>
            </section>
        </div>
    );
}
